import { startOfMonth } from 'date-fns';
import { endOfMonth } from 'date-fns/esm';
import React, { FunctionComponent } from 'react';
import { useProReviewsCountByDateQuery } from 'generated/graphql';
import { ProStatsProReviewsContainer } from './pro-stats-pro-reviews-container';

type Props = {
  startDate: Date;
  endDate: Date;
  proPresentationId: number;
};

export const ProStatsProReviewsRepository: FunctionComponent<Props> = ({
  startDate,
  endDate,
  proPresentationId,
}) => {
  const { data } = useProReviewsCountByDateQuery({
    variables: {
      before: startOfMonth(startDate),
      after: endOfMonth(endDate),
      proPresentationId: proPresentationId,
    },
  });

  return (
    <ProStatsProReviewsContainer
      countProReviewsByMonth={
        data?.countProReviewsWithStatusOkByMonthByProPresentation
      }
      startDate={startDate}
      endDate={endDate}
    />
  );
};
